module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr-mono.48585d916d782f51.svg";